var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 4,
    viewBox: "0 0 14 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00016 0.333252C1.0835 0.333252 0.333496 1.08325 0.333496 1.99992C0.333496 2.91659 1.0835 3.66658 2.00016 3.66658C2.91683 3.66658 3.66683 2.91659 3.66683 1.99992C3.66683 1.08325 2.91683 0.333252 2.00016 0.333252ZM12.0002 0.333252C11.0835 0.333252 10.3335 1.08325 10.3335 1.99992C10.3335 2.91659 11.0835 3.66658 12.0002 3.66658C12.9168 3.66658 13.6668 2.91659 13.6668 1.99992C13.6668 1.08325 12.9168 0.333252 12.0002 0.333252ZM7.00016 0.333252C6.0835 0.333252 5.3335 1.08325 5.3335 1.99992C5.3335 2.91659 6.0835 3.66658 7.00016 3.66658C7.91683 3.66658 8.66683 2.91659 8.66683 1.99992C8.66683 1.08325 7.91683 0.333252 7.00016 0.333252Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.e8258846e08765484b39c82a51ef71cd.svg";
export { ForwardRef as ReactComponent };